module.exports = "<div gw-loader=\"claimLoadPromise\"></div>"